export {getOffset} from '../../../src/utils/getOffset';
